import {
  Card as MantineCard,
  CardProps as MantineCardProps,
} from '@mantine/core';
import {
  ForwardRefExoticComponent,
  HTMLAttributes,
  RefAttributes,
  forwardRef,
} from 'react';

import styles from './Card.module.css';

export type CardVariant =
  'white' | 'white-border' | 'white-shadow' | 'blue' | 'grey';

export type CardRadius = 'xs' | 'md' | 'lg' | 'xl';

export type CardProps = Omit<
  MantineCardProps,
  | 'variant'
  | 'color'
  | 'styles'
  | 'classNames'
  | 'shadow'
  | 'radius'
  | 'withBorder'
  | 'size'
> &
  HTMLAttributes<HTMLDivElement> & {
    /** Visual variant. Default: 'white' */
    variant?: CardVariant;
    /** Border radius size. Default: 'xs' */
    radius?: CardRadius;
  };

const CardBase = forwardRef<HTMLDivElement, CardProps>(
  ({ variant = 'white', radius = 'xs', ...props }, ref) => {
    return (
      <MantineCard
        ref={ref}
        unstyled
        classNames={{ root: styles.root }}
        data-variant={variant}
        data-radius={radius}
        {...props}
      />
    );
  }
) as ForwardRefExoticComponent<CardProps & RefAttributes<HTMLDivElement>> & {
  Section: typeof MantineCard.Section;
};

CardBase.displayName = 'Card';
CardBase.Section = MantineCard.Section;

export const Card = CardBase;
